import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import './PrivacyPolicyPage.scss';

class PrivacyPolicyPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main
                role="main"
                className="conteneur conteneur-mobile"
                id="p-politique-de-confidentialite">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.PRIVACY_POLICY_PATH}`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: i18n.BREADCRUMB,
                            route: PATH.PRIVACY_POLICY_PATH
                        }
                    ]}
                />
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <p>{i18n.TEXT1_2}</p>
                <p>{i18n.TEXT1_3}</p>
                <ul>
                    <li>{i18n.TEXT1_4}</li>
                    <li>{i18n.TEXT1_5}</li>
                    <li>{i18n.TEXT1_6}</li>
                </ul>
                <p>{i18n.TEXT1_7}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>
                <p>{i18n.TEXT2_2}</p>
                <p>{i18n.TEXT2_3}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_4)}</p>
                <p>{i18n.TEXT2_5}</p>
                <p>{i18n.TEXT2_6}</p>
                <p>{i18n.TEXT2_7}</p>
                <p>{i18n.TEXT2_8}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <p>{i18n.TEXT3_2}</p>
                <p>{i18n.TEXT3_3}</p>
                <p>{i18n.TEXT3_4}</p>
                <p>{i18n.TEXT3_5}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>
                    <b>{i18n.TEXT4_2}</b>
                </p>
                <ul>
                    <li>{i18n.TEXT4_3}</li>
                    <li>{i18n.TEXT4_4}</li>
                    <li>{i18n.TEXT4_5}</li>
                    <li>{i18n.TEXT4_6}</li>
                    <li>{i18n.TEXT4_7}</li>
                </ul>
                <p>
                    <b>{i18n.TEXT4_8}</b>
                </p>
                <ul>
                    <li>{i18n.TEXT4_9}</li>
                    <li>{i18n.TEXT4_10}</li>
                    <li>{i18n.TEXT4_11}</li>
                </ul>
                <p>
                    <b>{i18n.TEXT4_12}</b>
                </p>
                <ul>
                    <li>{i18n.TEXT4_13}</li>
                    <li>{i18n.TEXT4_14}</li>
                    <li>{i18n.TEXT4_15}</li>
                    <li>{i18n.TEXT4_16}</li>
                </ul>
                <p>
                    <b>{i18n.TEXT4_17}</b>
                </p>
                <ul>
                    <li>{i18n.TEXT4_18}</li>
                    <li>{i18n.TEXT4_19}</li>
                    <li>{i18n.TEXT4_20}</li>
                    <li>{i18n.TEXT4_21}</li>
                    <li>{i18n.TEXT4_22}</li>
                    <li>{i18n.TEXT4_23}</li>
                </ul>
                <p>
                    <b>{i18n.TEXT4_24}</b>
                </p>
                <p>{i18n.TEXT4_25}</p>
                <p>{i18n.TEXT4_26}</p>
                <p>{i18n.TEXT4_27}</p>
                <p>
                    <b>{i18n.TEXT4_28}</b>
                </p>
                <p>{i18n.TEXT4_29}</p>
                <ul>
                    <li>{i18n.TEXT4_30}</li>
                    <li>{i18n.TEXT4_31}</li>
                    <li>{i18n.TEXT4_32}</li>
                    <li>{i18n.TEXT4_33}</li>
                    <li>{i18n.TEXT4_34}</li>
                    <li>{i18n.TEXT4_35}</li>
                    <li>{i18n.TEXT4_36}</li>
                </ul>
                <p>{i18n.TEXT4_37}</p>
                <ul>
                    <li>{i18n.TEXT4_38}</li>
                    <li>{i18n.TEXT4_39}</li>
                    <li>{i18n.TEXT4_40}</li>
                    <li>{i18n.TEXT4_41}</li>
                </ul>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>
                <p>
                    <b>{i18n.TEXT5_3}</b>
                </p>
                <p>{i18n.TEXT5_4}</p>
                <p>
                    <b>{i18n.TEXT5_5}</b>
                </p>
                <p>{i18n.TEXT5_6}</p>
                <p>
                    <b>{i18n.TEXT5_7}</b>
                </p>
                <p>{i18n.TEXT5_8}</p>
                <p>
                    <b>{i18n.TEXT5_9}</b>
                </p>
                <p>{i18n.TEXT5_10}</p>
                <p>
                    <b>{i18n.TEXT5_11}</b>
                </p>
                <p>{i18n.TEXT5_12}</p>
                <p>
                    <b>{i18n.TEXT5_13}</b>
                </p>
                <p>{i18n.TEXT5_14}</p>
                <p>{i18n.TEXT5_15}</p>
                <p>{i18n.TEXT5_16}</p>
                <p>
                    <b>{i18n.TEXT5_17}</b>
                </p>
                <p>{i18n.TEXT5_18}</p>
                <p>{i18n.TEXT5_19}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <p>{i18n.TEXT6_2}</p>
                <ul>
                    <li>{i18n.TEXT6_3}</li>
                    <li>{i18n.TEXT6_4}</li>
                    <li>{i18n.TEXT6_5}</li>
                    <li>{i18n.TEXT6_6}</li>
                    <li>{i18n.TEXT6_7}</li>
                </ul>
                <p>{i18n.TEXT6_8}</p>
                <p>{i18n.TEXT6_9}</p>
                <p>{i18n.TEXT6_10}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>
                <p>{i18n.TEXT7_2}</p>
                <p>{i18n.TEXT7_3}</p>
                <p>{i18n.TEXT7_4}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
                <p>{i18n.TEXT8_2}</p>
                <p>{i18n.TEXT8_3}</p>
                <ul>
                    <li>{i18n.TEXT8_4}</li>
                    <li>{i18n.TEXT8_5}</li>
                    <li>{i18n.TEXT8_6}</li>
                    <li>{i18n.TEXT8_7}</li>
                    <li>{i18n.TEXT8_8}</li>
                </ul>
                <p>{i18n.TEXT8_9}</p>

                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>
                <p>{i18n.TEXT9_3}</p>
                <p>{i18n.TEXT9_4}</p>
                <p>{i18n.TEXT9_5}</p>

                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>
                <ul>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_2)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_3)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_4)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_5)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_6)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_7)}</li>
                    <li>{convertHtmlToReactDomWithParams(i18n.TEXT10_8)}</li>
                </ul>
                <p>{i18n.TEXT10_9}</p>

                <h3>{i18n.TITLE11}</h3>
                <p>{i18n.TEXT11_1}</p>
                <p>{i18n.TEXT11_2}</p>
                <p>{i18n.TEXT11_3}</p>
                <p>{i18n.TEXT11_4}</p>

                <h3>{i18n.TITLE12}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT12_1)}</p>
                <p>{i18n.TEXT12_2}</p>

                <h3>{i18n.TITLE13}</h3>
                <p>{i18n.TEXT13_1}</p>
                <p>{i18n.TEXT13_2}</p>
                <p>{i18n.TEXT13_3}</p>
                <p>{i18n.TEXT13_4}</p>

                <h3>{i18n.TITLE14}</h3>
                <p>{i18n.TEXT14_1}</p>
                <p>{i18n.TEXT14_2}</p>
                <p>{i18n.TEXT14_3}</p>
            </main>
        );
    }
}

PrivacyPolicyPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.PRIVACY_POLICY
    };
}

export default withTemplate(connect(mapStateToProps)(PrivacyPolicyPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/privacypolicy/PrivacyPolicyPage.js